import { CHECKOUT_PLANS } from './constants';

export const isSingleOrder = (paymentOption) => paymentOption === CHECKOUT_PLANS.SINGLE_ORDER;
